(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity-react/assets/react/pages/integrity/integrity.js') >= 0) return;  svs.modules.push('/modules/terms-integrity-react/assets/react/pages/integrity/integrity.js');

'use strict';

const {
  logger
} = svs.termsIntegrity;
const {
  Footer,
  MainPage,
  TopMenu
} = svs.termsIntegrity.sharedComponents;
const {
  useGetCmsDataDocument,
  useGetCmsDataFolder
} = svs.termsIntegrity.sharedComponents;
const {
  DocList,
  FaqList
} = svs.termsIntegrity.sharedComponents;
const Integrity = () => {
  const {
    useState,
    useEffect
  } = React;
  const [docUrl, setDocUrl] = useState('');
  const faqPersonDataFolderId = ReactRedux.useSelector(state => state.termsIntegrity.faqPersonDataFolderId);
  const personDataFolderId = ReactRedux.useSelector(state => state.termsIntegrity.personDataFolderId);
  const {
    data: faqData,
    loading: faqLoading,
    dataError: faqDataError
  } = useGetCmsDataFolder(faqPersonDataFolderId);
  const {
    data: docData,
    loading: docLoading,
    dataError: docDataError
  } = useGetCmsDataFolder(personDataFolderId);

  const personDataDoc = ReactRedux.useSelector(state => state.termsIntegrity.personDataDoc);
  const {
    data: docSvSData
  } = useGetCmsDataDocument(personDataDoc);
  useEffect(() => {
    var _svs;
    const cdn = (_svs = svs) === null || _svs === void 0 || (_svs = _svs.core) === null || _svs === void 0 || (_svs = _svs.config) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.svsconfig) === null || _svs === void 0 ? void 0 : _svs.cdn2;
    if (docSvSData && docSvSData.length > 0) {
      logger.debug('useEffect to get specific dokument...');
      if (docSvSData[0].documentUrl) {
        const url = cdn + docSvSData[0].documentUrl;
        setDocUrl(url);
      }
    }
  }, [docSvSData]);
  return React.createElement(React.Fragment, null, React.createElement(TopMenu, null), React.createElement(MainPage, null, React.createElement("h2", null, "S\xE5 h\xE4r hanterar vi dina personuppgifter"), React.createElement("div", {
    className: "margin-xs-top-1"
  }, React.createElement("p", null, "Du ska vara trygg n\xE4r du anf\xF6rtror dina personuppgifter till Svenska Spel. Nedan finner du en sammanfattning om hur vi behandlar dessa. I", ' ', React.createElement("a", {
    className: "fc-sport-75",
    href: docUrl,
    rel: "noreferrer",
    target: "_blank"
  }, "Svenska Spels information om behandling av personuppgifter"), ' ', "hittar du en fullst\xE4ndig information i enlighet med dataskyddsf\xF6rordningens krav.", React.createElement("br", null), React.createElement("a", {
    className: "fc-sport-75",
    href: "https://business.safety.google/privacy/",
    rel: "noreferrer",
    target: "_blank"
  }, "Du kan \xE4ven l\xE4sa mer om hur Google behandlar personliga uppgifter."))), React.createElement("div", {
    className: "margin-xs-top-1 unstyled-nav"
  }, faqDataError && React.createElement("div", null, "Fel vid h\xE4mtning av FAQ"), faqLoading && React.createElement("div", null, "Laddar faq data..."), faqData && faqData.length > 0 && React.createElement(FaqList, {
    faqList: faqData
  })), React.createElement("div", {
    className: "margin-xs-top-4"
  }, docDataError && React.createElement("div", null, "Fel vid h\xE4mtning av dokument"), docLoading && React.createElement("div", null, "Laddar dokument..."), docData && docData.length > 0 && React.createElement(DocList, {
    docList: docData
  }))), React.createElement(Footer, null));
};
svs.termsIntegrity.integrity.Integrity = Integrity;

 })(window);